import { appData } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-accent-600">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
          {appData.title}
        </h2>
        <p className="text-sm md:text-base text-accent-100 leading-relaxed max-w-2xl mx-auto mb-8">
          {appData.description}
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {appData.features.map((feat) => (
            <span
              key={feat}
              className="px-4 py-1.5 bg-white/15 text-white text-sm rounded-full border border-white/20 whitespace-nowrap"
            >
              {feat}
            </span>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="w-full sm:w-auto px-8 py-3 bg-white text-accent-700 font-semibold rounded-full hover:bg-accent-50 transition-colors text-sm whitespace-nowrap cursor-pointer">
            <i className="ri-apple-fill mr-2"></i>
            {appData.badgeApple}
          </button>
          <button className="w-full sm:w-auto px-8 py-3 bg-white/10 text-white font-semibold rounded-full border border-white/30 hover:bg-white/20 transition-colors text-sm whitespace-nowrap cursor-pointer">
            <i className="ri-android-fill mr-2"></i>
            {appData.badgeAndroid}
          </button>
        </div>
      </div>
    </section>
  );
}